import {
  useOrganizationPresenceSubscription,
  usePresenceOverlaySync,
} from 'hooks/usePresenceCacheSync';

/**
 * Renders nothing. Mounting it subscribes to the organization presence
 * WebSocket channel and feeds presence deltas into the overlay slice that
 * `useTransferAgents` reads from.
 *
 * Mount it only while a transfer surface is open so the subscription stays
 * "active-while-open" rather than running app-wide. The subscription is
 * reference-counted, so sharing the channel with the presence sidebar is safe.
 */
export const TransferPresenceLiveUpdates = (): null => {
  useOrganizationPresenceSubscription();
  usePresenceOverlaySync();

  return null;
};
